import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IPaymentReceipt,
  IPaymentReceiptInitialState,
} from "./paymentreceiptModel";
import {
  createPaymentReceipt,
  deletePaymentReceipt,
  findAllActivePaymentReceipt,
  getAllPaymentReceipt,
  getPaymentReceiptById,
  updatePaymentReceipt,
} from "./services/paymentreceipt.services";

const initialState: IPaymentReceiptInitialState = {
  loading: false,
  formLoading: false,
  paymentreceiptDrawerOpen: false,
  error: "",
  PaymentReceiptList: [],
  PaymentReceiptID: null,
  PaymentReceiptDetail: {
    receipt_date: new Date(),
    karigar_id: null,
    amount: null,
    remarks: "",
  },
};

export const paymentreceiptSlice = createSlice({
  name: "paymentreceipt",
  initialState,
  reducers: {
    clearPaymentReceiptDetails: (state) => {
      state.PaymentReceiptDetail = initialState.PaymentReceiptDetail;
    },
    setPaymentReceiptID: (state, action) => {
      state.PaymentReceiptID = action.payload;
    },
    clearPaymentReceiptID: (state) => {
      state.PaymentReceiptID = null;
    },
    openPaymentReceiptDrawerOpen: (state) => {
      state.paymentreceiptDrawerOpen = true;
    },
    closePaymentReceiptDrawerOpen: (state) => {
      state.paymentreceiptDrawerOpen = false;
    },
  },
  extraReducers: (builder) => {
    /* For getAll ItemPaymentReceipt */

    builder.addCase(getAllPaymentReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPaymentReceipt.fulfilled,
      (state, action: PayloadAction<IPaymentReceipt[]>) => {
        state.loading = false;
        state.PaymentReceiptList = action.payload;
      }
    );
    builder.addCase(getAllPaymentReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PaymentReceiptList = [];
    });

    /* ForfindAllActivePaymentReceipt */

    builder.addCase(findAllActivePaymentReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActivePaymentReceipt.fulfilled,
      (state, action: PayloadAction<IPaymentReceipt[]>) => {
        state.loading = false;
        state.PaymentReceiptList = action.payload || [];
      }
    );
    builder.addCase(findAllActivePaymentReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PaymentReceiptList = [];
    });

    /* For createItemPaymentReceipt */

    builder.addCase(createPaymentReceipt.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createPaymentReceipt.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPaymentReceipt.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For updatePaymentReceipt */

    builder.addCase(updatePaymentReceipt.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePaymentReceipt.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePaymentReceipt.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For deletePaymentReceipt */

    builder.addCase(deletePaymentReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePaymentReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePaymentReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For PaymentReceiptActiveInactive */

    // builder.addCase(PaymentReceiptActiveInactive.pending, (state) => {
    //   state.loading = true;
    //   state.error = "";
    // });
    // builder.addCase(PaymentReceiptActiveInactive.fulfilled, (state) => {
    //   state.loading = false;
    // });
    // builder.addCase(PaymentReceiptActiveInactive.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Something went wrong";
    // });

    /* For getPaymentReceiptById */

    builder.addCase(getPaymentReceiptById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPaymentReceiptById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PaymentReceiptDetail = action.payload;
    });
    builder.addCase(getPaymentReceiptById.rejected, (state, action) => {
      state.formLoading = false;
      state.PaymentReceiptDetail = initialState.PaymentReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPaymentReceiptDetails,
  clearPaymentReceiptID,
  setPaymentReceiptID,
  closePaymentReceiptDrawerOpen,
  openPaymentReceiptDrawerOpen,
} = paymentreceiptSlice.actions;
export default paymentreceiptSlice.reducer;
